import type { JSX } from 'react';
import { TenantSelector } from './TenantSelector';
import styles from './UsabilityFilters.module.scss';

export interface UsabilityFiltersValue {
  tenantId: string;
  dateFrom: string;
  dateTo: string;
  page: string;
  module: string;
}

export function UsabilityFilters({
  value,
  onChange,
}: {
  value: UsabilityFiltersValue;
  onChange: (next: UsabilityFiltersValue) => void;
}): JSX.Element {
  return (
    <div className={styles.toolbar}>
      <TenantSelector
        value={value.tenantId}
        onChange={(tenantId) => onChange({ ...value, tenantId })}
      />
      <input
        type="date"
        className={styles.dateInput}
        value={value.dateFrom}
        onChange={(e) => onChange({ ...value, dateFrom: e.target.value })}
      />
      <input
        type="date"
        className={styles.dateInput}
        value={value.dateTo}
        onChange={(e) => onChange({ ...value, dateTo: e.target.value })}
      />
      <input
        type="text"
        className={styles.filterInput}
        placeholder="Página (ej. /inventarios)"
        value={value.page}
        onChange={(e) => onChange({ ...value, page: e.target.value })}
      />
      <input
        type="text"
        className={styles.filterInput}
        placeholder="Módulo (ej. INVENTARIOS)"
        value={value.module}
        onChange={(e) => onChange({ ...value, module: e.target.value })}
      />
    </div>
  );
}
